import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, MenuItem, Box, Typography, Alert } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../api/axiosConfig';

const createWorkOrder = async (data) => {
  const { data: res } = await axios.post('/workorders', data);
  return res;
};

const WorkOrderForm = ({ mechanics, onSuccess, onCancel }) => {
  const [form, setForm] = useState({
    title: '', description: '', type: 'maintenance', clientId: '', vehicleId: '', mechanicId: '',
    startTime: new Date(), endTime: new Date(new Date().setHours(new Date().getHours() + 2)), notes: '',
  });
  const [error, setError] = useState('');
  const queryClient = useQueryClient();
  const mutation = useMutation({ mutationFn: createWorkOrder, onSuccess: () => { queryClient.invalidateQueries(['workorders']); onSuccess(); }, onError: (err) => setError(err.response?.data?.message) });

  const handleSubmit = (e) => { e.preventDefault(); mutation.mutate(form); };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Typography variant="h5" mb={2}>Create Work Order</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}><TextField fullWidth label="Title" required value={form.title} onChange={e => setForm({...form, title: e.target.value})} /></Grid>
          <Grid item xs={12}><TextField fullWidth label="Description" multiline rows={2} value={form.description} onChange={e => setForm({...form, description: e.target.value})} /></Grid>
          <Grid item xs={6}><TextField select fullWidth label="Type" value={form.type} onChange={e => setForm({...form, type: e.target.value})}>
            <MenuItem value="maintenance">Maintenance</MenuItem><MenuItem value="repair">Repair</MenuItem><MenuItem value="installation">Installation</MenuItem>
          </TextField></Grid>
          <Grid item xs={6}><TextField select fullWidth label="Mechanic" value={form.mechanicId} onChange={e => setForm({...form, mechanicId: e.target.value})}>
            <MenuItem value="">Unassigned</MenuItem>
            {mechanics.map(m => <MenuItem key={m._id} value={m._id}>{m.fullName}</MenuItem>)}
          </TextField></Grid>
          <Grid item xs={6}><DateTimePicker label="Start Time" value={form.startTime} onChange={(v) => setForm({...form, startTime: v})} slotProps={{ textField: { fullWidth: true } }} /></Grid>
          <Grid item xs={6}><DateTimePicker label="End Time" value={form.endTime} onChange={(v) => setForm({...form, endTime: v})} slotProps={{ textField: { fullWidth: true } }} /></Grid>
          <Grid item xs={12}><TextField fullWidth label="Notes" multiline rows={2} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} /></Grid>
          <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
            <Button variant="outlined" onClick={onCancel}>Cancel</Button>
            <Button type="submit" variant="contained" disabled={mutation.isPending}>{mutation.isPending ? 'Creating...' : 'Create'}</Button>
          </Grid>
        </Grid>
      </form>
    </LocalizationProvider>
  );
};

export default WorkOrderForm;